// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import * as DmsCommon from './../supports/dms-common';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from '@mui/lab/DatePicker';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import IconButton from '@mui/material/IconButton';

import dayjs from 'dayjs';

import SelFolderDialog from './SelFolderDialog';
import * as SearchDialogJs from './SearchDialogContent';

export default function SearchCriteriaAddDialog(props) {

  const { open, isEdit, onClose, criteriaData, onOk, docTypes, folders } = props;



  // const [selFieldName, setSelFieldName] = useState("");
  // const [selOperator, setSelOperator] = useState("");
  const [criteriaStatus, setCriteriaStatus] = useState({});

  const [strValue, setStrValue] = useState("");
  const [selDocType, setSelDocType] = useState("");
  const [dateFormLabel, setDateFormLabel] = useState("");
  const [selDateFrom, setSelDateFrom] = useState(null);
  const [selDateTo, setSelDateTo] = useState(null);
  const [selFolderID, setSelFolderID] = useState(DmsCommon.VOID_FOLDER_ID);
  const [selFolderPath, setSelFolderPath] = useState("");
  const [connect, setConnect] = useState("and");

  const [showDocType, setShowDocType] = useState(false);
  const [showDtFrom, setShowDtFrom] = useState(false);
  const [showDtTo, setShowDtTo] = useState(false);
  const [showStrValue, setShowStrValue] = useState(false);
  const [showSelFolder, setShowSelFolder] = useState(false);

  const [operatorList, setOperatorList] = useState(SearchDialogJs.OPERATORS_ALL);


  useEffect(() => {
    if (open === true) {

      if (isEdit && criteriaData) {
        setCriteriaStatus(criteriaData);

        // console.log(' useEffect ~ criteriaData:', criteriaData);
        let strValue = '';
        let docTypeDesc = '';
        let dtFromValue = null;
        let dtToValue = null;
        let folderID = DmsCommon.VOID_FOLDER_ID;

        switch (criteriaData.fieldName) {
          case SearchDialogJs.FIELD_DOC_TYPE.value:
            docTypeDesc = criteriaData.value1;
            break;
          case SearchDialogJs.FIELD_DOC_DATE.value:
          case SearchDialogJs.FIELD_RECEIVE_DATE.value:
          case SearchDialogJs.FIELD_UPD_DATE.value:
            dtFromValue = criteriaData.value1;
            if (criteriaData.operator === "between") {
              dtToValue = criteriaData.value2;
            }
            break;
          case SearchDialogJs.FIELD_FOLDER.value:
            folderID = criteriaData.value1;
            break;
          case SearchDialogJs.FIELD_SUBJECT.value:
          case SearchDialogJs.FIELD_SENDER.value:
          case SearchDialogJs.FIELD_COMPANY.value:
          case SearchDialogJs.FIELD_RECIPIENT.value:
          case SearchDialogJs.FIELD_DOC_REF.value:
          case SearchDialogJs.FIELD_OUR_REF.value:
          case SearchDialogJs.FIELD_FILE_LOC.value:
          case SearchDialogJs.FIELD_KEYWORD.value:
          case SearchDialogJs.FIELD_UPD_BY.value:
            strValue = criteriaData.value1;
            break;
        }

        setStrValue(strValue);

        setSelDocType(docTypeDesc);
        setSelDateFrom(dtFromValue);
        setSelDateTo(dtToValue);

        const vSelFolder = folders.find(f => f.id === folderID);
        // console.log(' useEffect ~ vSelFolder:', vSelFolder);
        if (vSelFolder) {
          setSelFolderID(vSelFolder.id);
          setSelFolderPath(vSelFolder.FolderPath);
        } else {
          setSelFolderID(DmsCommon.VOID_FOLDER_ID);
          setSelFolderPath("");
        }


        setConnect(criteriaData.connect);

      } else {
        setCriteriaStatus({ fieldName: "", fieldDisplay: "", operator: "" });

        setStrValue("");
        setSelDocType("");
        setSelDateFrom(null);
        setSelDateTo(null);
        setSelFolderID(DmsCommon.VOID_FOLDER_ID);
        setSelFolderPath("");
        setConnect("and");
      }


    } else {
      setOperatorList(SearchDialogJs.OPERATORS_ALL);
    }
  }, [open]);

  const handleCloseClick = () => {

    onClose && onClose();
  }

  const handleOkClick = () => {

    // console.log('handleOkClick', editingData);

    onOk && onOk(editingData);
  }

  const handleConnectChange = (e) => {
    setConnect(e.target.value);
  }


  useEffect(() => {
    // console.log("useEffect[criteriaStatus]", criteriaStatus);

    // set Operator List
    switch (criteriaStatus.fieldName) {
      case SearchDialogJs.FIELD_DOC_DATE.value:
      case SearchDialogJs.FIELD_RECEIVE_DATE.value:
      case SearchDialogJs.FIELD_UPD_DATE.value:
        setOperatorList(SearchDialogJs.OPERATORS_DATE);
        // if (!CONDITION_INT_DATE.includes(criteriaStatus.operator)) {
        //   setSelOperator('');
        // }
        break;
      case SearchDialogJs.FIELD_FOLDER.value:
      case SearchDialogJs.FIELD_DOC_TYPE.value:
        setOperatorList(SearchDialogJs.OPERATORS_BOOL);
        // if (!CONDITION_BOOL.includes(criteriaStatus.operator)) {
        //   setSelOperator('');
        // }
        break;
      default:
        setOperatorList(SearchDialogJs.OPERATORS_STR);
    }




    // set Value controls
    switch (criteriaStatus.fieldName) {
      case SearchDialogJs.FIELD_DOC_TYPE.value:
        setShowStrValue(false);
        setShowDocType(true);
        setShowDtFrom(false);
        setShowDtTo(false);
        setShowSelFolder(false);
        break;
      case SearchDialogJs.FIELD_DOC_DATE.value:
      case SearchDialogJs.FIELD_RECEIVE_DATE.value:
      case SearchDialogJs.FIELD_UPD_DATE.value:
        setShowStrValue(false);
        setShowDocType(false);
        setShowSelFolder(false);

        if (criteriaStatus.operator === "between") {
          setShowDtFrom(true);
          setShowDtTo(true);

          setDateFormLabel("Date From");
        } else {
          setShowDtFrom(true);
          setShowDtTo(false);

          setDateFormLabel("Date");

        }

        break;
      case SearchDialogJs.FIELD_FOLDER.value:
        setShowStrValue(false);
        setShowDocType(false);
        setShowDtFrom(false);
        setShowDtTo(false);
        setShowSelFolder(true);
        break;
      case SearchDialogJs.FIELD_SUBJECT.value:
      case SearchDialogJs.FIELD_SENDER.value:
      case SearchDialogJs.FIELD_COMPANY.value:
      case SearchDialogJs.FIELD_RECIPIENT.value:
      case SearchDialogJs.FIELD_DOC_REF.value:
      case SearchDialogJs.FIELD_OUR_REF.value:
      case SearchDialogJs.FIELD_FILE_LOC.value:
      case SearchDialogJs.FIELD_KEYWORD.value:
      case SearchDialogJs.FIELD_UPD_BY.value:
        setShowStrValue(true);
        setShowDocType(false);
        setShowDtFrom(false);
        setShowDtTo(false);
        setShowSelFolder(false);
        break;
      default:
        setShowStrValue(false);
        setShowDocType(false);
        setShowDtFrom(false);
        setShowDtTo(false);
        setShowSelFolder(false);
    }


  }, [criteriaStatus]);


  const handleFieldNameChange = (e) => {
    const aValue = e.target.value;
    // console.log(' handleFieldNameChange ~ aValue:', aValue);
    const aField = SearchDialogJs.SEARCH_FIELD_LIST.find(f => f.value === aValue);
    // console.log(' handleFieldNameChange ~ aField:', aField);

    setCriteriaStatus({ ...criteriaData, fieldName: aValue, fieldDisplay: aField ? aField.label : "", operator: "" });

  };

  const handleConditionChange = (e) => {
    const aValue = e.target.value;

    setCriteriaStatus({ ...criteriaStatus, operator: aValue });
  };

  const handleStrValueChange = (e) => {
    setStrValue(e.target.value);
  };

  const handleDocTypeChange = (e) => {
    // console.log('handleDocTypeChange', e.target.value);
    setSelDocType(e.target.value);
  };

  const handleSelDateFromChange = (e) => {
    // console.log('handleSelDateChange', e);
    setSelDateFrom(e);
  };

  const handleSelDateToChange = (e) => {
    console.log('handleSelDateChange', e);
    setSelDateTo(e);
  };

  const [openFolderDialog, setOpenFolderDialog] = useState(false);

  const handleSelectFolderID = (aFolderID) => {
    // console.log("handleSelectFolderID", aFolderID);

    setOpenFolderDialog(false);

    const vSelFolder = folders.find(f => f.id === aFolderID);
    // console.log("vFolder", vFolder);

    if (vSelFolder) {
      setSelFolderID(vSelFolder.id);
      setSelFolderPath(vSelFolder.FolderPath);
    }

  }


  let value1 = null;
  let value2 = null;
  let valueDisplay1 = "";
  let valueDisplay2 = "";

  switch (criteriaStatus.fieldName) {
    case SearchDialogJs.FIELD_DOC_TYPE.value:
      value1 = selDocType;
      const findDocType = docTypes.find(t => t.RefCode === value1);
      if (findDocType) {
        valueDisplay1 = findDocType.RefCodeDesc;
      }
      break;
    case SearchDialogJs.FIELD_DOC_DATE.value:
    case SearchDialogJs.FIELD_RECEIVE_DATE.value:
    case SearchDialogJs.FIELD_UPD_DATE.value:
      value1 = selDateFrom;
      if (value1) {
        valueDisplay1 = dayjs(value1).format(DmsCommon.SHORT_DATE_FORMAT);
      }
      if (criteriaStatus.operator === "between") {
        value2 = selDateTo;
        if (value2) {
          valueDisplay2 = dayjs(value2).format(DmsCommon.SHORT_DATE_FORMAT);
        }
      }
      break;
    case SearchDialogJs.FIELD_FOLDER.value:
      value1 = selFolderID;
      valueDisplay1 = selFolderPath;
      break;
    case SearchDialogJs.FIELD_SUBJECT.value:
    case SearchDialogJs.FIELD_SENDER.value:
    case SearchDialogJs.FIELD_COMPANY.value:
    case SearchDialogJs.FIELD_RECIPIENT.value:
    case SearchDialogJs.FIELD_DOC_REF.value:
    case SearchDialogJs.FIELD_OUR_REF.value:
    case SearchDialogJs.FIELD_FILE_LOC.value:
    case SearchDialogJs.FIELD_KEYWORD.value:
    case SearchDialogJs.FIELD_UPD_BY.value:
      value1 = strValue;
      valueDisplay1 = strValue;
      break;
  }

  const editingData = {
    id: criteriaStatus.id,
    fieldName: criteriaStatus.fieldName,
    fieldDisplay: criteriaStatus.fieldDisplay,
    operator: criteriaStatus.operator,
    value1,
    valueDisplay1,
    value2,
    valueDisplay2,
    connect,
  }

  let disableSubmit = true;
  if (criteriaStatus.fieldName !== '' && criteriaStatus.operator !== '') {
    switch (criteriaStatus.fieldName) {
      case SearchDialogJs.FIELD_FOLDER.value:
        if (editingData.value1 !== DmsCommon.VOID_FOLDER_ID) {
          disableSubmit = false;
        }
        break;
      case SearchDialogJs.FIELD_DOC_DATE.value:
      case SearchDialogJs.FIELD_RECEIVE_DATE.value:
      case SearchDialogJs.FIELD_UPD_DATE.value:

        if (criteriaStatus.operator === "between") {
          if (editingData.value1 && editingData.value2) {
            disableSubmit = false;
          }
        } else {
          if (editingData.value1) {
            disableSubmit = false;
          }
        }
        break;
      default:
        if (editingData.value1 !== '') {
          disableSubmit = false;
        }

    }
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      aria-describedby="criteria-add-source-dialog-description"
    >

      <DialogTitle id="criteria-add-dialog-title">
        Criteria
      </DialogTitle>
      <DialogContent>
        <SelFolderDialog
          open={openFolderDialog}
          onClose={() => setOpenFolderDialog(false)}
          folders={folders}
          iniFolderID={selFolderID}
          disableAllFolder
          disablePhyLocFolder
          onSelectFolderID={handleSelectFolderID}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "400px", p: 1 }} >
          <Grid container spacing={{ xs: 2 }}  >
            <Grid item xs={12}>
              <RadioGroup
                aria-labelledby="connect-radio-buttons-group"
                name="connect-radio-buttons-group"
                value={connect}
                onChange={handleConnectChange}
                row
              >
                <FormControlLabel value="and" control={<Radio />} label="AND" />
                <FormControlLabel value="or" control={<Radio />} label="OR" />
              </RadioGroup>

            </Grid>

            <Grid item xs={12}>
              <TextField
                id="field-select"
                select
                label="Field"
                value={criteriaStatus.fieldName}
                onChange={handleFieldNameChange}
                fullWidth
                InputLabelProps={{ shrink: true, }}
              >

                {SearchDialogJs.SEARCH_FIELD_LIST.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>

            {criteriaStatus.fieldName != '' && (
              <Grid item xs={12}>
                <TextField
                  id="condition-select"
                  select
                  label="Condition"
                  value={criteriaStatus.operator}
                  onChange={handleConditionChange}
                  fullWidth
                  InputLabelProps={{ shrink: true, }}
                >
                  {operatorList.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}

                </TextField>

              </Grid>
            )}

            {showStrValue && (
              <Grid item xs={12}>
                <TextField
                  label="Value"
                  value={strValue}
                  onChange={handleStrValueChange}
                  fullWidth
                  InputLabelProps={{ shrink: true, }}
                />
              </Grid>
            )}


            {showDocType && (
              <Grid item xs={12}>
                <TextField
                  id="doctype-select"
                  select
                  label="Doc Type"
                  value={selDocType}
                  onChange={handleDocTypeChange}
                  fullWidth
                  InputLabelProps={{ shrink: true, }}
                >
                  {docTypes.map((option) => (
                    <MenuItem key={option.RefCode} value={option.RefCode}>
                      {option.RefCodeDesc}
                    </MenuItem>
                  ))}

                </TextField>

              </Grid>
            )}


            {showSelFolder && (
              <Grid item xs={12}>
                <TextField
                  label="Folder"
                  fullWidth
                  value={selFolderPath}
                  InputLabelProps={{ shrink: true, }}

                  InputProps={{
                    readOnly: true,
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => { setOpenFolderDialog(true) }}
                          onMouseDown={() => event.preventDefault()}
                          edge="end"
                        >
                          <FolderOpenIcon />
                        </IconButton>
                      </InputAdornment>
                  }}
                />
              </Grid>
            )}
            {showDtFrom && (
              <Grid item xs={12}>
                <DatePicker
                  label={dateFormLabel}
                  type="date"
                  value={selDateFrom}
                  onChange={handleSelDateFromChange}
                  renderInput={(params) => <TextField
                    fullWidth
                    {...params}
                    InputLabelProps={{ shrink: true, }}
                  />}
                />

              </Grid>
            )}
            {showDtTo && (
              <Grid item xs={12}>
                <DatePicker
                  label="Date To"
                  type="date"
                  value={selDateTo}
                  onChange={handleSelDateToChange}
                  renderInput={(params) => <TextField
                    fullWidth
                    {...params}
                    InputLabelProps={{ shrink: true, }}
                  />}
                />

              </Grid>
            )}


          </Grid>



        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button variant="contained" disabled={disableSubmit} onClick={handleOkClick} >Ok</Button>

      </DialogActions>
    </Dialog>

  );
}

SearchCriteriaAddDialog.propTypes = {
  open: PropTypes.bool,
  isEdit: PropTypes.bool,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
  criteriaData: PropTypes.object,
  docTypes: PropTypes.array,
  folders: PropTypes.array,
};
